export const doStartOver = (e, reload: boolean = true) => {
  // Clear session values
  Object.keys(sessionStorage).forEach((key) => sessionStorage.removeItem(key));
  // Clear shareId so the shared case won't reload
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete("shareId");
  searchParams.delete("patientCaseId");
  if (reload) {
    window.location.replace(`${window.location.pathname}?${searchParams}`);
  }
  // window.location.reload();
};
